import React from 'react';
import { Container,Row,Col,Card } from 'react-bootstrap';
import { useCountUp } from 'react-countup';
import { useDataContext } from '../DataContext'
const PlacementCounters = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { globalData } = useDataContext();
    useCountUp({
        ref: 'crOne',
        start:0,
        end: (globalData) ? globalData.sg_student_count : 2800,
        suffix:'+',
        enableScrollSpy: true,
    });
    useCountUp({
        ref: 'crTwo',
        start:0,
        end: (globalData) ? globalData.sg_placements_count : 2000,
        suffix:'+',
        enableScrollSpy: true,
    });
    useCountUp({
        ref: 'crThree',
        start:0,
        end: (globalData) ? globalData.sg_alumni_count : 2600,
        suffix:'+',
        enableScrollSpy: true,
      });
    return (
        <section className="ad-counter">
            <Container className="pb-5 text-center">
                <Row className='g-4' id="countup-target">
                    <Col md={4}>
                        <Card className='text-bg-info text-white p-3'>
                            <Card.Body className='border border-white'>
                                <div className="counters display-4 fw-bold">
                                    <span id='crOne' />
                                </div>
                                <div className="text fw-bold text-uppercase">
                                    {appLanguage === 'hi' ? 'छात्र' : 'Students'}
                                </div>
                            </Card.Body>
                        </Card>                       
                    </Col>
                    <Col md={4}>
                        <Card className='text-bg-info bg-info-subtle p-3'>
                            <Card.Body className='border border-white'>
                                <div className="counters display-4 fw-bold">
                                    <span id='crTwo' />
                                </div>
                                <div className="text fw-bold text-uppercase">
                                    {appLanguage === 'hi' ? 'नियुक्तियाँ' : 'Placements'}
                                </div>
                            </Card.Body>
                        </Card> 
                    </Col>
                    <Col md={4}>
                        <Card className='text-bg-info text-white p-3'>
                            <Card.Body className='border border-white'>
                                <div className="counters display-4 fw-bold">
                                    <span id='crThree' />
                                </div>
                                <div className="text fw-bold text-uppercase">
                                    {appLanguage === 'hi' ? 'भूतपूर्व छात्र' : 'Alumni'}
                                </div>
                            </Card.Body>
                        </Card> 
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
export default PlacementCounters;